import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {timeout} from "../../decorators/timeout";
import * as _ from 'lodash';

@Component({
  selector: 'app-loading',
  styleUrls: ['./loading.scss'],
  templateUrl: './loading.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoadingComponent {

  _style: object;
  _size: object;
  _type = 0;
  _ready = undefined;

  @Input()
  src = '';

  @Input('style')
  set style(i_style: object) {
    this._style = i_style;
  }

  @Input('type')
  set type(i_type: any) {
    if (i_type === -1) {
      this._type = _.random(4, 10);
      // console.log('>>>>>> random loader ' + this._type);
    } else {
      this._type = Number(i_type);
    }
  }

  @Input('size')
  set size(i_size) {
    const cleanSize = i_size.replace('px', '').replace('em', '');
    if (_.isNumber(Number(cleanSize))) {
      const center = cleanSize / 2;
      const offset = {'position': 'relative', 'left': -`${center}px`};
      if (this._style) {
        this._style = Object.assign(this._style, offset);
      } else {
        this._style = offset;
      }
    }

    this._size = {
      opacity: 1,
      height: i_size,
      width: i_size
    };
  }

  constructor(private cd: ChangeDetectorRef) {
    this.ready();
  }

  @timeout(15)
  ready() {
    this._ready = true;
    this.cd.markForCheck();
  }
}
